import React from 'react';

const hasDocument = typeof document !== 'undefined';
const vendorEvents = [
  {
    hidden: 'hidden',
    event: 'visibilitychange',
    state: 'visibilityState',
  },
] as const;

const isSupported = hasDocument && Boolean(document.addEventListener);

const visibility = (() => {
  if (!isSupported) {
    return null;
  }
  for (const event of vendorEvents) {
    if (event.hidden in document) {
      return event;
    }
  }

  return null;
})();

const getHandlerArgs = (): [boolean, 'hidden' | 'visible'] => {
  if (!visibility) {
    return [true, 'visible'];
  }

  const { hidden, state } = visibility;
  return [!document[hidden], document[state]];
};

export const usePageVisibility = () => {
  const initiallyVisible = getHandlerArgs();

  const [isVisible, setIsVisible] = React.useState(initiallyVisible);

  React.useEffect(() => {
    if (isSupported && visibility) {
      const handler = () => {
        const currentlyVisible = getHandlerArgs();

        setIsVisible(currentlyVisible);
      };

      document.addEventListener(visibility.event, handler);

      return () => {
        document.removeEventListener(visibility.event, handler);
      };
    }
  }, []);

  return isVisible;
};
